import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    selectPortraitLibrary = '';
    singlePathExceedingThreshold = '';
    fixedLengthStatistics = '';
    effectiveDateAndTime = '';
    formData = {};
    detail;
    onDataChange(detail) {
        // console.log(55555);
        this.formData = { ...this.formData, ...detail };
    }
    mounted() {
        this.formData = { ...this.formData, ...this.detail };
    }
};
__decorate([
    Prop()
], default_1.prototype, "detail", void 0);
__decorate([
    Watch('detail')
], default_1.prototype, "onDataChange", null);
default_1 = __decorate([
    Component({
        name: 'TrafficStatisticsExceedTheLimit'
    })
], default_1);
export default default_1;
